class ContributorInvitation {
  invitationId: number;

  constructor(params?: ContributorInvitationType) {
    this.invitationId = params?.invitationId || -1;
  }
}

export { ContributorInvitation };
